/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Priority_SupportInputs */

const en_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority Helpdesk Support`)
};

const es_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte Prioritario`)
};

const fr_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance technique prioritaire`)
};

const de_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorisierter Helpdesk-Support`)
};

const id_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukungan Helpdesk Prioritas`)
};

/** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */
const ja_pricing_feature_priority_support = en_pricing_feature_priority_support;

/** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */
const zh_pricing_feature_priority_support = en_pricing_feature_priority_support;

/** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */
const ar_pricing_feature_priority_support = en_pricing_feature_priority_support;

/** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */
const it_pricing_feature_priority_support = en_pricing_feature_priority_support;

/** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */
const ru_pricing_feature_priority_support = en_pricing_feature_priority_support;

/** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */
const pt_pricing_feature_priority_support = en_pricing_feature_priority_support;

/** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */
const ko_pricing_feature_priority_support = en_pricing_feature_priority_support;

/**
* | output |
* | --- |
* | "Priority Helpdesk Support" |
*
* @param {Pricing_Feature_Priority_SupportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_priority_support = /** @type {((inputs?: Pricing_Feature_Priority_SupportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Priority_SupportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_priority_support(inputs)
	if (locale === "es") return es_pricing_feature_priority_support(inputs)
	if (locale === "fr") return fr_pricing_feature_priority_support(inputs)
	if (locale === "de") return de_pricing_feature_priority_support(inputs)
	if (locale === "ja") return ja_pricing_feature_priority_support(inputs)
	if (locale === "zh") return zh_pricing_feature_priority_support(inputs)
	if (locale === "ar") return ar_pricing_feature_priority_support(inputs)
	if (locale === "id") return id_pricing_feature_priority_support(inputs)
	if (locale === "it") return it_pricing_feature_priority_support(inputs)
	if (locale === "ru") return ru_pricing_feature_priority_support(inputs)
	if (locale === "pt") return pt_pricing_feature_priority_support(inputs)
	return ko_pricing_feature_priority_support(inputs)
});